<div class="m-aside-menu  m-aside-menu--skin-dark m-aside-menu--submenu-skin-dark">
  <ul class="m-menu__nav  m-menu__nav--dropdown-submenu-arrow">

    <li *ngIf="showHideHint" class="sidebar-hide-hint">
      <i class="la la-eye-slash sidebar-hide-hint-icon"></i>
      <span class="sidebar-hide-hint-body">
        <span class="sidebar-hide-hint-text-hover">{{ 'sidebar.hideHint' | transloco }}</span>
        <span class="sidebar-hide-hint-text-touch">{{ 'sidebar.hideHintTouch' | transloco }}</span>
      </span>
      <button class="sidebar-hide-hint-close"
              (click)="dismissHideHint()"
              [attr.aria-label]="'sidebar.hideHintDismiss' | transloco">
        <i class="la la-times"></i>
      </button>
    </li>

    <ng-container *ngFor="let entry of annotatedVisibleItems">
      <li *ngIf="entry.sectionTitle !== null" class="m-menu__section" [title]="'mainmenu.' + entry.sectionTitle | transloco">
        <h4 class="m-menu__section-text">
          {{ 'mainmenu.' + entry.sectionTitle | transloco }}
        </h4>
        <i class="m-menu__section-icon la la-ellipsis-h"></i>
      </li>

      <li class="m-menu__item sidebar-item"
          routerLinkActive="m-menu__item--active">
        <a [routerLink]="routerLink(entry.item)" [queryParams]="entry.item.queryParams" class="m-menu__link">
          <i *ngIf="entry.item.sub" class="m-menu__link-icon la" [ngClass]="'la-' + entry.item.icon" [title]="'mainmenu.' + entry.item.sub + '.' + entry.item.title | transloco"></i>
          <i *ngIf="!entry.item.sub" class="m-menu__link-icon la" [ngClass]="'la-' + entry.item.icon" [title]="'mainmenu.' + entry.item.title | transloco"></i>

          <span class="m-menu__link-title">
            <span class="m-menu__link-wrap">
              <span *ngIf="entry.item.sub" class="m-menu__link-text">
                {{ ('mainmenu.' + entry.item.sub + '.' + entry.item.title) | transloco }}
              </span>
              <span *ngIf="!entry.item.sub" class="m-menu__link-text">
                {{ ('mainmenu.' + entry.item.title) | transloco }}
              </span>
            </span>
          </span>
        </a>

        <button class="sidebar-eye-btn"
                [disabled]="savingInProgress"
                (click)="hideTab(entry.item.id)"
                [title]="'sidebar.hideTab' | transloco"
                [attr.aria-label]="'sidebar.hideTab' | transloco">
          <i class="la la-eye-slash"></i>
        </button>
      </li>
    </ng-container>

    <!-- Hidden tabs group — always rendered when hiddenCount > 0 so user can recover -->
    <ng-container *ngIf="hiddenCount > 0">
      <li class="m-menu__item sidebar-hidden-group-header" (click)="toggleHiddenGroup()">
        <a class="m-menu__link">
          <i class="m-menu__link-icon la la-eye-slash"></i>
          <span class="m-menu__link-title">
            <span class="m-menu__link-wrap">
              <span class="m-menu__link-text">
                {{ 'sidebar.hiddenTabs' | transloco }}
              </span>
            </span>
          </span>
          <i class="la sidebar-hidden-group-chevron" [ngClass]="hiddenGroupExpanded ? 'la-angle-up' : 'la-angle-down'"></i>
        </a>
      </li>

      <ng-container *ngIf="hiddenGroupExpanded">
        <ng-container *ngFor="let entry of annotatedHiddenItems">
          <li *ngIf="entry.sectionTitle !== null" class="m-menu__section m-menu__section--hidden-group" [title]="'mainmenu.' + entry.sectionTitle | transloco">
            <h4 class="m-menu__section-text">
              {{ 'mainmenu.' + entry.sectionTitle | transloco }}
            </h4>
            <i class="m-menu__section-icon la la-ellipsis-h"></i>
          </li>

          <li class="m-menu__item sidebar-hidden-item">
            <a [routerLink]="routerLink(entry.item)" [queryParams]="entry.item.queryParams" class="m-menu__link">
              <i *ngIf="entry.item.sub" class="m-menu__link-icon la" [ngClass]="'la-' + entry.item.icon" [title]="'mainmenu.' + entry.item.sub + '.' + entry.item.title | transloco"></i>
              <i *ngIf="!entry.item.sub" class="m-menu__link-icon la" [ngClass]="'la-' + entry.item.icon" [title]="'mainmenu.' + entry.item.title | transloco"></i>

              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span *ngIf="entry.item.sub" class="m-menu__link-text sidebar-hidden-label">
                    {{ ('mainmenu.' + entry.item.sub + '.' + entry.item.title) | transloco }}
                  </span>
                  <span *ngIf="!entry.item.sub" class="m-menu__link-text sidebar-hidden-label">
                    {{ ('mainmenu.' + entry.item.title) | transloco }}
                  </span>
                </span>
              </span>
            </a>

            <button class="sidebar-eye-btn sidebar-restore-btn"
                    [disabled]="savingInProgress"
                    (click)="unhideTab(entry.item.id)"
                    [title]="'sidebar.showTab' | transloco"
                    [attr.aria-label]="'sidebar.showTab' | transloco">
              <i class="la la-eye"></i>
            </button>
          </li>
        </ng-container>
      </ng-container>
    </ng-container>

    <li class="m-menu__section">
      <h4 class="m-menu__section-text">
        {{ 'sidebar.user' | transloco }}
      </h4>
      <i class="m-menu__section-icon la la-ellipsis-h"></i>
    </li>

    <li class="m-menu__item">
      <a [href]="profileUrl" target="_blank" class="m-menu__link">
        <i class="m-menu__link-icon la la-male"></i>

        <span class="m-menu__link-title">
          <span class="m-menu__link-wrap">
            <span class="m-menu__link-text">
              {{ 'sidebar.profile' | transloco }}
            </span>
          </span>
        </span>
      </a>
    </li>

    <li class="m-menu__item m--visible-tablet-and-mobile">
      <a (click)="logout()" class="m-menu__link">
        <i class="m-menu__link-icon la la-sign-out"></i>

        <span class="m-menu__link-title">
          <span class="m-menu__link-wrap">
            <span class="m-menu__link-text">
              {{ 'sidebar.logOff' | transloco }}
            </span>
          </span>
        </span>
      </a>
    </li>
  </ul>
</div>
